/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import history from '../../../core/history';

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

class Link extends React.Component {
  handleClick = (event) => {
    if (window && window.NProgress) {
      window.NProgress.start()
    }
    const { urlGenerator } = this.context
    if (this.props.onClick) {
      this.props.onClick(event);
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    event.preventDefault();
    if (!/^http/.test(this.props.to)) {
      history.push(urlGenerator(this.props.to, this.props.extraParams));
    } else {
      window.open(urlGenerator(this.props.to, this.props.extraParams))
      // location.href = urlGenerator(this.props.to)
    }
  };

  render() {
    const { urlGenerator } = this.context
    const { to, children, extraParams, ...props } = this.props
    return (
      <a
        ref={a => (this.domnode = a)}
        href={urlGenerator(to, extraParams)}
        {...props}
        onClick={this.handleClick}
      >
        {children}
      </a>
    )
  }
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
  onClick: PropTypes.func,
  extraParams: PropTypes.object,
}

Link.defaultProps = {
  children: null,
  onClick: () => false,
  extraParams: null,
}

Link.contextTypes = {
  urlGenerator: React.PropTypes.func,
}

export default Link;



// WEBPACK FOOTER //
// ./src/components/common/Link/index.js